import { render } from "./PanelItem.vue?vue&type=template&id=d8ce6e32&scoped=true"
import script from "./PanelItem.vue?vue&type=script&lang=js"
export * from "./PanelItem.vue?vue&type=script&lang=js"

import "./PanelItem.vue?vue&type=style&index=0&id=d8ce6e32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ce6e32"]])

export default __exports__